import { useState } from "react"
import { useTranslation } from "react-i18next"
import PageLayout from "components/layout/PageLayout"
import CostRefundCard from "./views/CostRefundCard"
import CostRefundRequestModal from "./components/CostRefundRequestModal"
import { useGetMyCostRefundsQuery } from "./api/costRefundApiSlice"
import PaginationBar from "components/widget/PaginationBar"


const MyCostRefunds = () => {

    const [t, i18n] = useTranslation(["global", "absenceReport"])
    const [requestPage, setRequestPage] = useState(0)

    const changePage = (page) => {
        console.log("Requesting page" + page + "...")
        setRequestPage(page)
    }

    const {
        data: response,
        isFetching,
        isLoading,
        isSuccess,
        isError,
        error,
        refetch,
    } = useGetMyCostRefundsQuery(requestPage)


    let refunds = [

        {
            guid: "fgggfd",
            title: "Trasferta Roma",
            status: "SENT",
            user: {
                "guid": "1272eaec-6ba8-457e-8266-9d519e25468f",
                "displayName": "Alexis Hill",
                "email": "",
                "title": null
            },
            startDate: 1715264158,
            endDate: 1715436958,
            createdDate: 1715264158000,
            distance: 600,
            attachments: [],
            expenseItems: [],
            totalExpense: null
        },

        {
            guid: "aowdjo",
            title: "Cena con cliente",
            status: "ACCEPTED",
            user: {
                "guid": "1272eaec-6ba8-457e-8266-9d519e25468f",
                "displayName": "Alexis Hill",
                "email": "",
                "title": null
            },
            startDate: 1715264158,
            endDate: 1715436958,
            createdDate: 1715264158000,
            distance: null,
            attachments: [
                {
                    fileName: "SC_2024_05_11_1",
                    url: "domain.com/file?id=we3of34uo3"
                }
            ],
            expenseItems: [
                {
                    name: "Ristorante",
                    import: 120
                },
                {
                    name: "Aperitivo",
                    import: 48
                }
            ],
            totalExpense: 168.00
        },
        {
            guid: "f5df46",
            title: "Cena con cliente",
            status: "SENT",
            user: {
                "guid": "1272eaec-6ba8-457e-8266-9d519e25468f",
                "displayName": "Mario Rossi",
                "email": "",
                "title": null
            },
            startDate: 1715119200,
            endDate: 1715378400,
            createdDate: 1715264158000,
            distance: 340,
            attachments: [
                {
                    fileName: "SC_2024_05_11_1",
                    url: "domain.com/file?id=we3of34uo3"
                }
            ],
            expenseItems: [
                {
                    name: "Ristorante",
                    import: 96
                }
            ],
            totalExpense: 96.00
        }
    ]

    let content =
        <>
            <div className="mb-4">
                <CostRefundRequestModal />
            </div>
            {
                isSuccess &&
                <>
                    <div className="row row-cols-1 row-cols-md-3 g-4">
                        {response.content.map(refund => (
                            <CostRefundCard
                                key={refund.guid}
                                refund={refund}
                            />
                        ))}
                    </div>
                    <PaginationBar
                        currentPage={requestPage + 1}
                        postsPerPage={response.pageable.pageSize}
                        totalPosts={response.totalElements}
                        paginate={(e) => {
                            console.log(e)
                            setRequestPage(e - 1)
                        }}
                    />
                </>
            }
        </>

    return <PageLayout
        pageTitle={t("absenceReport:menu.my_cost_refunds")}
        bodyContent={content}
        onPageRefresh={refetch}
        isError={isError}
        errorMsg={error != null ? error.status : "Generic Error"}
        isLoadingPage={isLoading}
        isLoadingContent={isFetching}
    />

}

export default MyCostRefunds